import RuleRic6 from './RIC_6'

export default {
  ...RuleRic6,
  gradeLevelId: 8
}
